import React, { memo } from 'react';
import { BookOpen } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { usePlaybookStatus } from './PlaybookStatusContext';

function PlaybookMarkerInner({ personId, className = '' }) {
  const { statuses, isLoading } = usePlaybookStatus();

  if (isLoading) {
    return null;
  }

  if (personId == null || String(personId) === '') {
    return null;
  }

  if (statuses[personId] !== true) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={`cursor-help ${className}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <BookOpen className="w-3.5 h-3.5 text-green-600 fill-green-100" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        align="center"
        className="bg-[#0A1A2F] text-white border-0 shadow-lg"
      >
        <p className="text-xs">Active in playbook</p>
      </TooltipContent>
    </Tooltip>
  );
}

export default memo(PlaybookMarkerInner);
